import { IPublicClientApplication } from "@azure/msal-browser";
import { authMode } from "./authSettings";

export const getSignedInAccount = (instance: IPublicClientApplication) => {
  if (!instance) throw new Error("PCA is not initialized");

  const accounts = instance.getAllAccounts();
  if (accounts.length === 0) return;

  return accounts.find(
    (acc) =>
      //select the correct account considering B2C or AAD auth method
      (authMode === "b2c" &&
        acc.environment === process.env.REACT_APP_AUTH_B2C_DOMAIN) ||
      acc.environment !== process.env.REACT_APP_AUTH_B2C_DOMAIN
  );
};
